module.exports = __webpack_public_path__ + "img/search.0840bc38.svg";